import styled from 'styled-components';

import {
  SkeletonHeadline as SkeletonHeadlineComponent,
  SkeletonProfileImage as SkeletonProfileImageComponent,
} from '@xingternal/skeleton';
import { scale090, spaceM, spaceS } from '@xingternal/tokens';

export const SkeletonProfileImage = styled(SkeletonProfileImageComponent)`
  margin-bottom: ${spaceM};
`;

export const SkeletonHeadline = styled(SkeletonHeadlineComponent)`
  margin-bottom: ${spaceS};

  & > div {
    margin-bottom: ${spaceS};
    height: ${scale090};
  }
`;
